module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Decisiones"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 200,
      "imaSrc": "design/banco1-1-3-2",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Decisiones',
      "videoEmbed": "ADMINISTRACIONDINERO8Decisiones (ant39).mp4"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInUp",
    attrs: {
      "xs12": "",
      "sm5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 233,
      "imaSrc": "contenido/diapositiva_10",
      "imaAlt": "Mujer sonriendo recostada en el cuadro de texto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeInRight dura_1",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('p', {
    staticClass: "adorn-bottom"
  }, [_vm._v("Es mucho más fácil tomar las decisiones cuando sabemos para dónde vamos, cuando tenemos claras nuestras "), _c('strong', [_vm._v("metas")]), _vm._v(".\r\n        "), _c('br'), _c('br'), _vm._v("Cada "), _c('strong', [_vm._v("decisión")]), _vm._v(" que tomamos trae consigo una "), _c('strong', [_vm._v("consecuencia")]), _vm._v(", por eso "), _c('strong', [_vm._v("es necesario tomar decisiones efectivas")]), _vm._v(", es decir,\r\n          que apunten a lo que queremos lograr, optimizando los recursos y siendo congruentes con nuestros objetivos.\r\n          "), _c('audio-player', {
    ref: "audioPlayer",
    attrs: {
      "audios": [
        'Administracion2.mp3'
      ]
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-542f6c24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-09.vue
// module id = 979
// module chunks = 1